module.exports = __webpack_public_path__ + "static/img/FLE.ea5c018e.jpg";